define.alias("shared/utils/focus", "settings/utils/focus");